import { createStoreEnhance } from '@halo/zustand-enhance';
import type { CreateMediaStateOptions, MediaStateStore } from './media';
import { mediaStoreCreator } from './media';

export type CreateMediaOptions = CreateMediaStateOptions;

export type MediaStore = MediaStateStore;

export const createMediaStore = (options: CreateMediaOptions) => {
  const useMediaStore = createStoreEnhance<MediaStore>((...args) => ({
    ...mediaStoreCreator(...args),
  }));

  const { createMediaState } = useMediaStore.getState();

  createMediaState(options);

  return useMediaStore;
};

export type MediaStoreInstance = ReturnType<typeof createMediaStore>;
